var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464 359",
    style: {
      enableBackground: "new 0 0 464 359"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FF8500;}\n\t.st2{fill:#FFC200;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,596.8v-38h9.8c3.7,0,6.5,0.8,8.6,2.4c2.1,1.6,3.1,4,3.1,7.1c0,4-1.7,6.8-5.1,8.4 c2.7,0.4,4.8,1.4,6.3,3.1s2.2,3.8,2.2,6.4c0,2.2-0.5,4.1-1.5,5.6c-1,1.6-2.4,2.8-4.2,3.6s-4,1.3-6.5,1.3H55.1z M61.1,574.9h2.5 c2.3,0,4.1-0.5,5.3-1.5c1.2-1,1.9-2.4,1.9-4.2c0-1.8-0.6-3.2-1.8-4.2c-1.2-0.9-3-1.4-5.4-1.4h-2.5V574.9z M61.1,592.1h4.8 c2.6,0,4.5-0.5,5.8-1.5c1.3-1,2-2.5,2-4.4c0-1.9-0.7-3.4-2-4.5c-1.4-1.1-3.3-1.6-5.8-1.6h-4.8V592.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,596.8v-38h20.4v5.3H93.2v11H107v5.3H93.2v11.1h14.4v5.3H87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117,596.8v-38h20.4v5.3h-14.4v11h13.8v5.3h-13.8v11.1h14.4v5.3H117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.2,596.8l4.2-38h6.4l9.8,25.9l9.8-25.9h6.4l4.2,38h-6l-3-27l-9.5,25.6h-3.8l-9.5-25.6l-3,27H157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.8,596.8v-16.7l-13.5-21.2h7.2l9.3,15l9.3-15h7.3l-13.5,21.2v16.7H211.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.9,597.6c-2.6,0-5-0.5-7.3-1.5c-2.3-1-4.2-2.4-5.9-4.2c-1.7-1.8-3-3.9-4-6.3c-1-2.4-1.4-5-1.4-7.8 c0-2.6,0.4-5.1,1.3-7.5c0.9-2.4,2.2-4.5,3.8-6.3c1.7-1.8,3.7-3.3,6-4.3c2.4-1.1,5-1.6,7.9-1.6c1.8,0,3.5,0.2,5.2,0.6 c1.7,0.4,3.3,1,4.8,1.8c1.5,0.8,2.9,1.7,4.1,2.8l-2.9,4.6c-1.4-1.4-3.1-2.5-5.1-3.3c-2-0.8-4-1.2-6.1-1.2c-2,0-3.8,0.4-5.4,1.1 s-2.9,1.7-4,3s-1.9,2.8-2.5,4.5c-0.6,1.7-0.8,3.5-0.8,5.5c0,2.1,0.3,4,0.9,5.8c0.6,1.8,1.5,3.3,2.6,4.6s2.4,2.3,3.9,3 c1.5,0.7,3.1,1.1,4.8,1.1c1.4,0,2.8-0.2,4.1-0.7s2.5-1.1,3.5-2c1-0.9,1.9-1.9,2.5-3.1c0.6-1.2,0.9-2.5,0.9-3.9v-0.8h-11.4v-4.7 h17.6v4.9c0,2.4-0.5,4.6-1.5,6.6s-2.3,3.6-4,5c-1.7,1.4-3.5,2.4-5.6,3.2C270.2,597.2,268.1,597.6,265.9,597.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305,597.6c-4.6,0-8.1-1.2-10.5-3.6c-2.4-2.4-3.5-5.9-3.5-10.6v-24.4h6v22.8c0,3.5,0.6,6,1.9,7.6 c1.3,1.6,3.3,2.4,6,2.4s4.8-0.8,6-2.4c1.3-1.6,1.9-4.1,1.9-7.6v-22.8h6v24.4c0,4.7-1.2,8.3-3.5,10.6 C313.1,596.4,309.6,597.6,305,597.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.4,596.8v-38h20.4v5.3h-14.4v11h13.8v5.3h-13.8v11.1h14.4v5.3H329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.1,597.6c-1.8,0-3.5-0.2-5-0.7c-1.5-0.5-2.8-1-3.9-1.7c-1.1-0.7-2.1-1.4-2.8-2.1c-0.8-0.7-1.3-1.3-1.8-1.7 l3.2-4.9c0.4,0.4,1,1,1.6,1.6s1.4,1.2,2.3,1.8s1.9,1.1,3,1.5c1.1,0.4,2.3,0.6,3.6,0.6c1.2,0,2.4-0.2,3.3-0.6c1-0.4,1.8-1,2.3-1.9 c0.6-0.8,0.9-1.8,0.9-3c0-1.1-0.2-2-0.7-2.7c-0.4-0.8-1.1-1.4-1.9-2c-0.8-0.6-1.8-1.1-2.9-1.6c-1.1-0.5-2.4-1-3.7-1.6 c-1-0.4-1.9-0.9-2.9-1.5c-1-0.6-1.8-1.2-2.6-2c-0.8-0.8-1.4-1.6-1.9-2.6s-0.7-2.2-0.7-3.5c0-1.4,0.3-2.8,0.8-4.1 c0.6-1.3,1.3-2.4,2.4-3.5c1-1,2.2-1.8,3.7-2.4c1.4-0.6,3-0.9,4.8-0.9c1.4,0,2.8,0.2,4.2,0.6s2.6,1,3.7,1.6c1.1,0.7,2,1.4,2.7,2.1 l-2.6,4.6c-0.6-0.6-1.3-1.2-2.1-1.7c-0.8-0.5-1.7-1-2.7-1.3c-1-0.3-2-0.5-3.1-0.5c-1.3,0-2.3,0.2-3.2,0.7c-0.9,0.5-1.5,1.1-2,1.9 c-0.5,0.8-0.7,1.7-0.7,2.6c0,0.8,0.2,1.5,0.5,2c0.3,0.6,0.8,1,1.4,1.4c0.6,0.4,1.2,0.8,2,1.1c0.8,0.3,1.6,0.7,2.4,1 c1.7,0.7,3.2,1.4,4.6,2.1c1.4,0.7,2.6,1.5,3.7,2.3c1,0.9,1.9,1.9,2.4,3.1c0.6,1.2,0.9,2.7,0.9,4.3c0,2.4-0.6,4.4-1.7,6.1 c-1.1,1.7-2.7,3-4.7,3.9C373.9,597.1,371.7,597.6,369.1,597.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.8,596.8v-32.6h-10.3v-5.4h26.7v5.4h-10.3v32.6H394.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.3,239.3V119.7c0-18.5-9.8-35.5-25.8-44.8L257.8,15.1c-16-9.2-35.7-9.2-51.7,0L102.5,74.9 c-16,9.2-25.8,26.3-25.8,44.8v119.6c0,18.5,9.8,35.5,25.8,44.8l103.6,59.8c16,9.2,35.7,9.2,51.7,0l103.6-59.8 C377.4,274.8,387.3,257.8,387.3,239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.9,94.6h-31.8c-6.2,0-12,3.3-15.1,8.7l-15.9,27.5c-3.1,5.4-3.1,12,0,17.4l15.9,27.5 c3.1,5.4,8.8,8.7,15.1,8.7h31.8c6.2,0,12-3.3,15.1-8.7l15.9-27.5c3.1-5.4,3.1-12,0-17.4l-15.9-27.5 C259.8,97.9,254.1,94.6,247.9,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.9,190.8h-31.8c-6.2,0-12,3.3-15.1,8.7L185.1,227c-3.1,5.4-3.1,12,0,17.4l15.9,27.5 c3.1,5.4,8.8,8.7,15.1,8.7h31.8c6.2,0,12-3.3,15.1-8.7l15.9-27.5c3.1-5.4,3.1-12,0-17.4l-15.9-27.5 C259.8,194.1,254.1,190.8,247.9,190.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.4,184.5l116-86.2c0,0,60.6-51.8,71-17.7C464.7,114.5,428.7,189.3,267.4,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.6,184.5l-116-86.2c0,0-60.6-51.8-71-17.7S34.3,189.3,195.6,184.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21effa881277b4c3c80d163e138cd10e.svg";
export { ForwardRef as ReactComponent };